// Star.Ryhwa Product Catalog - With real photos, separated stickers, and separated tote bags
// Set active: true (ON) or active: false (OFF) to toggle any item's visibility

const products = [
  {
    "id": 1,
    "name": "Sticker - 'In the Seom' BTS RM",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "3KGCJSSGB4ZTCNXN7SLKBBBT",
    "squareVariationId": "3KGCJSSGB4ZTCNXN7SLKBBBT",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - 'In the Seom' BTS RM - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_rm.jpg",
    "sanityAssetId": "image-4bc843b894d87981addea58f8a5532f84da87419-2160x2880-jpg",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 2,
    "name": "Sticker - BTS 'In the Seom' Jin",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "DWMITOBNRKV7OJLUTGMG5HMH",
    "squareVariationId": "DWMITOBNRKV7OJLUTGMG5HMH",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - BTS 'In the Seom' Jin - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_jin.webp",
    "sanityAssetId": "image-b37478cb4c67cdcea35664ba4dda630b90184f67-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 3,
    "name": "Sticker - BTS 'In the Seom' Suga",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "L7XQMGCETPWDQR23K6VCXA4Y",
    "squareVariationId": "L7XQMGCETPWDQR23K6VCXA4Y",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - BTS 'In the Seom' Suga - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_suga.webp",
    "sanityAssetId": "image-e94f83936b53d4a9365171d94299b37350c8598a-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 4,
    "name": "Sticker - BTS 'In the Seom' J-Hope",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "NI2OVMLKJ5OJFVG7JS6G5JN6",
    "squareVariationId": "NI2OVMLKJ5OJFVG7JS6G5JN6",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - BTS 'In the Seom' J-Hope - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_jhope.webp",
    "sanityAssetId": "image-13f4741bfc0096ad52dc6e41db1771fad8c3133b-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 5,
    "name": "Sticker - BTS 'In the Seom' Jimin",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "QGO67GNTTUWLFADM6PARYDKQ",
    "squareVariationId": "QGO67GNTTUWLFADM6PARYDKQ",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - BTS 'In the Seom' Jimin - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_jimin.webp",
    "sanityAssetId": "image-42cadf7e6988a9ee6ea2f9e4096b6f822ae8d1ce-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 6,
    "name": "Sticker - BTS 'In the Seom' V",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "FFSJOU5VMQBHWTO6O2TL3TIA",
    "squareVariationId": "FFSJOU5VMQBHWTO6O2TL3TIA",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - BTS 'In the Seom' V - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_v.webp",
    "sanityAssetId": "image-58e2046123aca0d4082a326773bcb0721268517c-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 7,
    "name": "Sticker - BTS 'In the Seom' Jungkook",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "3R5B3ZP4W43R6XI23A5EKQC5",
    "squareVariationId": "3R5B3ZP4W43R6XI23A5EKQC5",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - BTS 'In the Seom' Jungkook - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_jungkook.webp",
    "sanityAssetId": "image-2d82bbd25c70858fb4fb465428490d205906daba-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 8,
    "name": "Sticker - You never walk alone - BTS",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "U3FWVVPUMMD25OINCW7PPXJD",
    "squareVariationId": "U3FWVVPUMMD25OINCW7PPXJD",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - You never walk alone - BTS - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_ynwa.webp",
    "sanityAssetId": "image-25ecd9fc9b411ef9c6d4c27149213d52ffae0ba5-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 9,
    "name": "Sticker - 00:00 (Zero O'clock) - BTS",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "SV26J5IGMSWWU3NKMDJKMSNV",
    "squareVariationId": "SV26J5IGMSWWU3NKMDJKMSNV",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - 00:00 (Zero O'clock) - BTS - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_bts_zero_oclock.webp",
    "sanityAssetId": "image-9391f7fd3e04e755bb3d85ecf697118e3fb99010-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 10,
    "name": "Sticker - Lovesick girls Ticket",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "62BP4EUTFZMVZSU45S6OKPYC",
    "squareVariationId": "62BP4EUTFZMVZSU45S6OKPYC",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - Lovesick girls Ticket - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_lovesick_girls.webp",
    "sanityAssetId": "image-aa8ce16b764fce47251071c9a8cb52b7ece60f6b-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 11,
    "name": "Sticker - MOA Club Ticket",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "NIXFYOSUOGTIXEX7XYGOKSAK",
    "squareVariationId": "NIXFYOSUOGTIXEX7XYGOKSAK",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - MOA Club Ticket - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_moa_ticket.webp",
    "sanityAssetId": "image-5a9fc3739e362dc9ee930c198a5137fba3cdb802-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 12,
    "name": "Sticker - ANTI-ROMANTIC",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "FDYJS74KYS7V3II35HUMP3RB",
    "squareVariationId": "FDYJS74KYS7V3II35HUMP3RB",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - ANTI-ROMANTIC - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_anti_romantic.webp",
    "sanityAssetId": "image-e824ce2126368d69f5cb4a24d27509334fe50b5b-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 13,
    "name": "Sticker - Soobin yk soobin?",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "XJSLBAEXRAGDLXVWJ2QOO5ER",
    "squareVariationId": "XJSLBAEXRAGDLXVWJ2QOO5ER",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - Soobin yk soobin? - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_soobin.webp",
    "sanityAssetId": "image-71278b04f9ed0f8a7547d4fdca390ba79b1cbbfb-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 14,
    "name": "Sticker - Derpy Tiger",
    "price": "$4",
    "priceNum": 4,
    "category": "Stickers",
    "squareCatalogId": "L5DSL3S7LNC72TR3JKO43TOZ",
    "squareVariationId": "L5DSL3S7LNC72TR3JKO43TOZ",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sticker - Derpy Tiger - Authentic high quality Star.Ryhwa vinyl decal sticker.",
    "image": "/photos/sticker_derpy_tiger.webp",
    "sanityAssetId": "image-94ffddedefd21ff3a096036f3acb4ccd37c802ea-768x1024-webp",
    "tags": [
      "Stickers",
      "Decal",
      "K-Pop"
    ]
  },
  {
    "id": 15,
    "name": "Tote Bag - BTS White",
    "price": "$25",
    "priceNum": 25,
    "category": "Bags",
    "squareCatalogId": "3YGO73J3QCPBYZFNOY2XNFBJ",
    "squareVariationId": "3YGO73J3QCPBYZFNOY2XNFBJ",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Tote Bag - BTS White - Heavyweight canvas aesthetic tote bag featuring custom fan art & motifs.",
    "image": "/photos/totes_overview.webp",
    "sanityAssetId": "image-76f603714f85f8584c0f9caefc1d74a6274f17e6-768x1024-webp",
    "gallery": [
      "/photos/totes_overview.webp",
      "/photos/totes_overview.webp"
    ],
    "tags": [
      "Totes",
      "Bags",
      "Canvas"
    ]
  },
  {
    "id": 16,
    "name": "Tote Bag - Smisky Black",
    "price": "$25",
    "priceNum": 25,
    "category": "Bags",
    "squareCatalogId": "OT3H5HC23JLHKXU6W5GPHF74",
    "squareVariationId": "OT3H5HC23JLHKXU6W5GPHF74",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Tote Bag - Smisky Black - Heavyweight canvas aesthetic tote bag featuring custom fan art & motifs.",
    "image": "/photos/tote_smisky_black.webp",
    "sanityAssetId": "image-54efe590a561c2c50676715e07c49f4cec569799-768x1024-webp",
    "gallery": [
      "/photos/tote_smisky_black.webp",
      "/photos/totes_overview.webp"
    ],
    "tags": [
      "Totes",
      "Bags",
      "Canvas"
    ]
  },
  {
    "id": 17,
    "name": "Tote Bag - Smiski white",
    "price": "$25",
    "priceNum": 25,
    "category": "Bags",
    "squareCatalogId": "SCQQQPTWWF5OEA5ZUACLECMG",
    "squareVariationId": "SCQQQPTWWF5OEA5ZUACLECMG",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Tote Bag - Smiski white - Heavyweight canvas aesthetic tote bag featuring custom fan art & motifs.",
    "image": "/photos/totes_overview.webp",
    "sanityAssetId": "image-76f603714f85f8584c0f9caefc1d74a6274f17e6-768x1024-webp",
    "gallery": [
      "/photos/totes_overview.webp",
      "/photos/totes_overview.webp"
    ],
    "tags": [
      "Totes",
      "Bags",
      "Canvas"
    ]
  },
  {
    "id": 18,
    "name": "Tote Bag - BTS Black",
    "price": "$25",
    "priceNum": 25,
    "category": "Bags",
    "squareCatalogId": "6LHW46FI3I75O4G55L7TQ6GO",
    "squareVariationId": "6LHW46FI3I75O4G55L7TQ6GO",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Tote Bag - BTS Black - Heavyweight canvas aesthetic tote bag featuring custom fan art & motifs.",
    "image": "/photos/tote_bts_black.webp",
    "sanityAssetId": "image-6b35eb6fda0fa82f4bd201a090537707b58747ca-768x1024-webp",
    "gallery": [
      "/photos/tote_bts_black.webp",
      "/photos/totes_overview.webp"
    ],
    "tags": [
      "Totes",
      "Bags",
      "Canvas"
    ]
  },
  {
    "id": 19,
    "name": "Mystery Bag - Small Mystery Bag",
    "price": "$15",
    "priceNum": 15,
    "category": "Bags",
    "squareCatalogId": "6V3TODY2TZZ6UJOJLC3FGEYX",
    "squareVariationId": "6V3TODY2TZZ6UJOJLC3FGEYX",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Mystery Bag - Small Mystery Bag - Curated surprise mystery bag loaded with stickers, photocards, charms, and fan merch!",
    "image": "/photos/totes_overview.webp",
    "sanityAssetId": "image-76f603714f85f8584c0f9caefc1d74a6274f17e6-768x1024-webp",
    "tags": [
      "Mystery Bags",
      "Bags"
    ]
  },
  {
    "id": 20,
    "name": "Mystery Bag - Big Mystery Bag w/tote",
    "price": "$40",
    "priceNum": 40,
    "category": "Bags",
    "squareCatalogId": "Q4ERH4ANE4MB7C22SQ3UMXUP",
    "squareVariationId": "Q4ERH4ANE4MB7C22SQ3UMXUP",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Mystery Bag - Big Mystery Bag w/tote - Curated surprise mystery bag loaded with stickers, photocards, charms, and fan merch!",
    "image": "/photos/totes_overview.webp",
    "sanityAssetId": "image-76f603714f85f8584c0f9caefc1d74a6274f17e6-768x1024-webp",
    "tags": [
      "Mystery Bags",
      "Bags"
    ]
  },
  {
    "id": 21,
    "name": "Mystery Bag - Big Mystery Bag",
    "price": "$30",
    "priceNum": 30,
    "category": "Bags",
    "squareCatalogId": "JY3UHKNYFQ4LWXAVHTHHUGTC",
    "squareVariationId": "JY3UHKNYFQ4LWXAVHTHHUGTC",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Mystery Bag - Big Mystery Bag - Curated surprise mystery bag loaded with stickers, photocards, charms, and fan merch!",
    "image": "/photos/totes_overview.webp",
    "sanityAssetId": "image-76f603714f85f8584c0f9caefc1d74a6274f17e6-768x1024-webp",
    "tags": [
      "Mystery Bags",
      "Bags"
    ]
  },
  {
    "id": 22,
    "name": "Eco Bags - Foldable Shopper Tote",
    "price": "$15",
    "priceNum": 15,
    "category": "Bags",
    "squareCatalogId": "P7EOWUXPT4OCLEI24U2HOMF5",
    "squareVariationId": "P7EOWUXPT4OCLEI24U2HOMF5",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Compact foldable reusable eco tote bags featuring custom cute character patterns (BTS, SKZOO, KDH).",
    "image": "/photos/ecobags_overview.webp",
    "sanityAssetId": "image-4e583031c53fe176c96c0c07f7d88f457a8486a8-768x1024-webp",
    "gallery": [
      "/photos/ecobags_overview.webp",
      "/photos/ecobag_purple_bts.webp",
      "/photos/ecobag_black_bts.webp",
      "/photos/ecobag_blue_skzoo.webp",
      "/photos/ecobag_red_kdh.webp"
    ],
    "tags": [
      "Bags",
      "Eco Bags",
      "Reusable"
    ]
  },
  {
    "id": 23,
    "name": "Custom Hand Sanitizer Keychains",
    "price": "$13",
    "priceNum": 13,
    "category": "Sanitizer Keychains",
    "squareCatalogId": "RWSP6NWSGFGVJ4EZLAUNREUO",
    "squareVariationId": "RWSP6NWSGFGVJ4EZLAUNREUO",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "isCustomizable": true,
    "description": "Handcrafted pocket spray sanitizer keychain with custom character charms & whipped accents (*comes empty/refillable).",
    "image": "/photos/sanitizer_group_overview_1.webp",
    "gallery": [
      "/photos/sanitizer_group_overview_1.webp",
      "/photos/sanitizer_group_overview_2.webp",
      "/photos/sanitizer_pink_skzoo_jiniret.webp",
      "/photos/sanitizer_green_pokemon_snorlax.webp",
      "/photos/sanitizer_orange_one_piece_luffy.webp",
      "/photos/sanitizer_blue_one_piece_chopper.webp",
      "/photos/sanitizer_purple_kpop_girl.webp",
      "/photos/sanitizer_pink_bt21_tata.webp"
    ],
    "types": [
      {
        "name": "Purple",
        "squareVariationId": "RWSP6NWSGFGVJ4EZLAUNREUO",
        "image": "/photos/sanitizer_purple_kpop_girl.webp",
        "inStock": true
      },
      {
        "name": "Green",
        "squareVariationId": "EFMGO2MAPAPC4RUBBTBLPIOL",
        "image": "/photos/sanitizer_green_demon_slayer_tomioka.webp",
        "inStock": true
      },
      {
        "name": "Yellow",
        "squareVariationId": "DSPPF6LVMEWEXJQR4MGKK72F",
        "image": "/photos/sanitizer_group_overview_1.webp",
        "inStock": true
      },
      {
        "name": "Blue",
        "squareVariationId": "7O4U2PDYV7PXPDURCK6Q73QD",
        "image": "/photos/sanitizer_blue_one_piece_chopper.webp",
        "inStock": true
      },
      {
        "name": "Pink",
        "squareVariationId": "GJ4YQJBATTWFKUV2G7LLHOCN",
        "image": "/photos/sanitizer_pink_skzoo_jiniret.webp",
        "inStock": true
      },
      {
        "name": "Orange",
        "squareVariationId": "VJDJVIZG3RFFX2E3UKRCGDB4",
        "image": "/photos/sanitizer_orange_one_piece_luffy.webp",
        "inStock": true
      }
    ],
    "tags": [
      "Sanitizer Keychains",
      "Charms",
      "Deco"
    ]
  },
  {
    "id": 24,
    "name": "Custom K-Pop Collages",
    "price": "$10",
    "priceNum": 10,
    "category": "Collages",
    "squareCatalogId": "VKBS2LW6KR4CQDKNB3XVQNCG",
    "squareVariationId": "VKBS2LW6KR4CQDKNB3XVQNCG",
    "itemType": "custom",
    "inStock": true,
    "active": true,
    "isCustomizable": true,
    "description": "100% Authentic photobook cuts and album imagery upcycled into handcrafted K-Pop collages.",
    "image": "/photos/collage_kpop_group_overview.webp",
    "gallery": [
      "/photos/collage_kpop_group_overview.webp",
      "/photos/collage_zb1_ricky.webp",
      "/photos/collage_txt_taehyun.webp",
      "/photos/collage_ateez_hongjoong.webp",
      "/photos/collage_bts_jungkook.webp"
    ],
    "types": [
      {
        "name": "ZB1: Ricky",
        "image": "/photos/collage_zb1_ricky.webp",
        "inStock": true
      },
      {
        "name": "TXT: Taehyun",
        "image": "/photos/collage_txt_taehyun.webp",
        "inStock": true
      },
      {
        "name": "ATEEZ: Hongjoong",
        "image": "/photos/collage_ateez_hongjoong.webp",
        "inStock": true
      },
      {
        "name": "BTS: Jungkook",
        "image": "/photos/collage_bts_jungkook.webp",
        "inStock": true
      },
      {
        "name": "All Members (Group Shot)",
        "image": "/photos/collage_kpop_group_overview.webp",
        "inStock": true
      }
    ],
    "tags": [
      "Collages",
      "K-Pop Album",
      "Custom"
    ]
  },
  {
    "id": 25,
    "name": "K-Pop Hand Fans",
    "price": "$15",
    "priceNum": 15,
    "category": "Hand Fans",
    "squareCatalogId": "XWEQ73RG6XWVT53OJI66AXSL",
    "squareVariationId": "XWEQ73RG6XWVT53OJI66AXSL",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Double-sided holographic & concert-ready handcrafted K-Pop hand fans.",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "types": [
      {
        "name": "Straykids (RED)",
        "squareVariationId": "XWEQ73RG6XWVT53OJI66AXSL",
        "inStock": true
      },
      {
        "name": "ATEEZ (BLUE)",
        "squareVariationId": "DYPNTY3FSCJD3EPFW3M47CZP",
        "inStock": true
      }
    ],
    "tags": [
      "Hand Fans",
      "Concert Merch",
      "K-Pop"
    ]
  },
  {
    "id": 26,
    "name": "Microfiber Aesthetic Towels",
    "price": "$20",
    "priceNum": 20,
    "category": "Towels",
    "squareCatalogId": "56S732MWJE6OCMF2VOOQBANE",
    "squareVariationId": "56S732MWJE6OCMF2VOOQBANE",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Plush high-definition microfiber concert slogans and cheering towels.",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "types": [
      {
        "name": "Black",
        "squareVariationId": "56S732MWJE6OCMF2VOOQBANE",
        "inStock": true
      },
      {
        "name": "Purple",
        "squareVariationId": "T5KE3ZNQUH53BD4IVRJ2SHJZ",
        "inStock": true
      }
    ],
    "tags": [
      "Towels",
      "Concert Towels"
    ]
  },
  {
    "id": 27,
    "name": "Keychains - Shaker & Charm",
    "price": "$10",
    "priceNum": 10,
    "category": "Keychains",
    "squareCatalogId": "V57IKWVKLKLB7V25QGSR2T23",
    "squareVariationId": "V57IKWVKLKLB7V25QGSR2T23",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Handcrafted acrylic shaker and character keychains with holographic sparkle details.",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "types": [
      {
        "name": "Shaker",
        "squareVariationId": "V57IKWVKLKLB7V25QGSR2T23",
        "inStock": true
      },
      {
        "name": "Keychain",
        "squareVariationId": "EFHXBZTX5FM4KLR4TGZMMDCS",
        "inStock": true
      }
    ],
    "tags": [
      "Keychains",
      "Shaker Keychains"
    ]
  },
  {
    "id": 28,
    "name": "Photocard Holders",
    "price": "$10",
    "priceNum": 10,
    "category": "Photocard Holders",
    "squareCatalogId": "PD2QYZ3RSQCGDEN5XIVIVTCG",
    "squareVariationId": "PD2QYZ3RSQCGDEN5XIVIVTCG",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Custom deco photocard holders to keep your favorite bias PC safe and stylish.",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "types": [
      {
        "name": "PC holder",
        "squareVariationId": "PD2QYZ3RSQCGDEN5XIVIVTCG",
        "inStock": true
      },
      {
        "name": "Cream PC holder",
        "squareVariationId": "DCTR4RQZQQJH3DZXWQSK7WUC",
        "inStock": true
      }
    ],
    "tags": [
      "Photocard Holders",
      "Toploaders"
    ]
  },
  {
    "id": 29,
    "name": "Photocards (Official & Unofficial)",
    "price": "$2",
    "priceNum": 2,
    "category": "Photocard Holders",
    "squareCatalogId": "BRUKZW7K3Z5MCHRHMJEHFY6G",
    "squareVariationId": "BRUKZW7K3Z5MCHRHMJEHFY6G",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Official album pulls and custom aesthetic fanmade photocards.",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "types": [
      {
        "name": "Unofficial PC",
        "squareVariationId": "BRUKZW7K3Z5MCHRHMJEHFY6G",
        "inStock": true
      },
      {
        "name": "Official PC",
        "squareVariationId": "SJUORDIOEY2FN4G2KL6MSTSF",
        "inStock": true
      }
    ],
    "tags": [
      "Photocards",
      "Photocard Holders"
    ]
  },
  {
    "id": 30,
    "name": "BTS Enamel Pins Collection",
    "price": "$8",
    "priceNum": 8,
    "category": "Enamel Pins",
    "squareCatalogId": "IZGK5ET43T5MUD5XH7C6SNON",
    "squareVariationId": "IZGK5ET43T5MUD5XH7C6SNON",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Collector hard enamel pins featuring iconic BTS eras, lyrics, and character art.",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "types": [
      {
        "name": "P2 BLACK SWAN",
        "squareVariationId": "IZGK5ET43T5MUD5XH7C6SNON",
        "inStock": true
      },
      {
        "name": "P1 DISCO BTS",
        "squareVariationId": "6HSJVIMUJ6RYDE23WPMVGCSE",
        "inStock": true
      },
      {
        "name": "P3 Ice Cream BTS",
        "squareVariationId": "E4MKMBHG6MYXH2MWDMRUM7TO",
        "inStock": true
      },
      {
        "name": "P4 V & JK LAP",
        "squareVariationId": "2NBJVKIDPIRNGMPRGXD4OZ4Y",
        "inStock": true
      },
      {
        "name": "P5 V&JK Dance",
        "squareVariationId": "LG45RFHQIURH3EEVEEQKUNGP",
        "inStock": true
      },
      {
        "name": "P6 V&JK Silver",
        "squareVariationId": "ZWJRTFH3CHSVTD5HRMQPRNST",
        "inStock": true
      },
      {
        "name": "P7 soulmate JM & V",
        "squareVariationId": "2QQMF6AX3KPIVGD5P7JPZ2HW",
        "inStock": true
      },
      {
        "name": "P8 Yet to come",
        "squareVariationId": "NVDK72OTTW7P5ZNNDZGJA3MD",
        "inStock": true
      },
      {
        "name": "P9 V DNA",
        "squareVariationId": "PXHJE6R6INWKQ7MTIPV2T56R",
        "inStock": true
      },
      {
        "name": "P10 JK Shirtless",
        "squareVariationId": "V4ENBSKYWW7W2PCEN76UJAP3",
        "inStock": true
      },
      {
        "name": "P11 JK HAND",
        "squareVariationId": "7ILYV3FFOJ26VHB6NNACH2KM",
        "inStock": true
      },
      {
        "name": "P12 Soju",
        "squareVariationId": "SL2L2OUW77W2UMVYOHGKDFKK",
        "inStock": true
      },
      {
        "name": "P13 soda pop",
        "squareVariationId": "SWCAL7BSBHVHNVVQEFOVXSYN",
        "inStock": true
      },
      {
        "name": "P14 coffee Lucky",
        "squareVariationId": "FCNQJKF6CSLFK6FNR77U3Z2E",
        "inStock": true
      },
      {
        "name": "P15 MOA",
        "squareVariationId": "FMAP5UNETULV2I64MHZX355M",
        "inStock": true
      },
      {
        "name": "P16 Lucky & Frosty",
        "squareVariationId": "OWLKXEEL4MAO46FH65RZUEVE",
        "inStock": true
      },
      {
        "name": "P1",
        "squareVariationId": "FYKAN2QVSHNLCTRVKSOR7T6Y",
        "inStock": true
      }
    ],
    "tags": [
      "Enamel Pins",
      "BTS",
      "Pins"
    ]
  },
  {
    "id": 31,
    "name": "2 for35",
    "price": "$35",
    "priceNum": 35,
    "category": "Bags",
    "squareCatalogId": "3OA7HXYQCDZL5AHWFBII3ACY",
    "squareVariationId": "3OA7HXYQCDZL5AHWFBII3ACY",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "2 for35 - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 32,
    "name": "3 for $10",
    "price": "$10",
    "priceNum": 10,
    "category": "Bags",
    "squareCatalogId": "KOCYBZZ7DV6ACBI4B2ENWK3U",
    "squareVariationId": "KOCYBZZ7DV6ACBI4B2ENWK3U",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "3 for $10 - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 33,
    "name": "BTS Mugs",
    "price": "$15",
    "priceNum": 15,
    "category": "Bags",
    "squareCatalogId": "5L7KJLDYV3BW5KJMC3USPGNV",
    "squareVariationId": "5L7KJLDYV3BW5KJMC3USPGNV",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "BTS Mugs - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 34,
    "name": "Diffuser",
    "price": "$25",
    "priceNum": 25,
    "category": "Bags",
    "squareCatalogId": "R5PPDKXHFW6VYF7QTNPUTANV",
    "squareVariationId": "R5PPDKXHFW6VYF7QTNPUTANV",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Diffuser - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 35,
    "name": "Hand pin",
    "price": "$6",
    "priceNum": 6,
    "category": "Enamel Pins",
    "squareCatalogId": "4LQADF7TLYI2D376JJ4C3JFW",
    "squareVariationId": "4LQADF7TLYI2D376JJ4C3JFW",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Hand pin - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Enamel Pins"
    ]
  },
  {
    "id": 36,
    "name": "LADS TOPLOADER",
    "price": "$12",
    "priceNum": 12,
    "category": "Photocard Holders",
    "squareCatalogId": "3DFVCGRRPC5FIQPLL4BU5HMC",
    "squareVariationId": "3DFVCGRRPC5FIQPLL4BU5HMC",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "LADS TOPLOADER - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Photocard Holders"
    ]
  },
  {
    "id": 37,
    "name": "Official PC",
    "price": "$10",
    "priceNum": 10,
    "category": "Photocard Holders",
    "squareCatalogId": "N7YUSDFSJPJP7Y2APIQVIEGZ",
    "squareVariationId": "N7YUSDFSJPJP7Y2APIQVIEGZ",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Official PC - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Photocard Holders"
    ]
  },
  {
    "id": 38,
    "name": "Ornament Big",
    "price": "$10",
    "priceNum": 10,
    "category": "Bags",
    "squareCatalogId": "BPHCSP2ANPMR4L3ILLVGXS5X",
    "squareVariationId": "BPHCSP2ANPMR4L3ILLVGXS5X",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Ornament Big - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 39,
    "name": "Ornament SM",
    "price": "$8",
    "priceNum": 8,
    "category": "Bags",
    "squareCatalogId": "AAN42ZMHY4TKUZXKDLIFNZJ5",
    "squareVariationId": "AAN42ZMHY4TKUZXKDLIFNZJ5",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Ornament SM - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 40,
    "name": "Prints",
    "price": "$1",
    "priceNum": 1,
    "category": "Photocard Holders",
    "squareCatalogId": "OKUK3Z6KRN4MPYBCLAJLEK6E",
    "squareVariationId": "OKUK3Z6KRN4MPYBCLAJLEK6E",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Prints - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Photocard Holders"
    ]
  },
  {
    "id": 41,
    "name": "SMALL PINS",
    "price": "$8",
    "priceNum": 8,
    "category": "Enamel Pins",
    "squareCatalogId": "6S3LIBVVHYVCWKO4TMCVY7I6",
    "squareVariationId": "6S3LIBVVHYVCWKO4TMCVY7I6",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "SMALL PINS - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Enamel Pins"
    ]
  },
  {
    "id": 42,
    "name": "Shaker Keychain",
    "price": "$9",
    "priceNum": 9,
    "category": "Keychains",
    "squareCatalogId": "EFLQJZNSSUPU7QL6P2JJ7WCC",
    "squareVariationId": "EFLQJZNSSUPU7QL6P2JJ7WCC",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Shaker Keychain - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Keychains"
    ]
  },
  {
    "id": 43,
    "name": "Shirts",
    "price": "$25",
    "priceNum": 25,
    "category": "Bags",
    "squareCatalogId": "HWM5AFW46NPUG3BY4ON2BZWT",
    "squareVariationId": "HWM5AFW46NPUG3BY4ON2BZWT",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Shirts - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Bags"
    ]
  },
  {
    "id": 44,
    "name": "Sm PINS",
    "price": "$7",
    "priceNum": 7,
    "category": "Enamel Pins",
    "squareCatalogId": "L6JPNVPUYAJJR6MZT6HS7JAB",
    "squareVariationId": "L6JPNVPUYAJJR6MZT6HS7JAB",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "Sm PINS - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Enamel Pins"
    ]
  },
  {
    "id": 45,
    "name": "UN official pc",
    "price": "$2",
    "priceNum": 2,
    "category": "Photocard Holders",
    "squareCatalogId": "7IWLESJXFPCBLSN3PNUYLEST",
    "squareVariationId": "7IWLESJXFPCBLSN3PNUYLEST",
    "itemType": "ready-to-ship",
    "inStock": true,
    "active": true,
    "description": "UN official pc - Handcrafted K-Pop merch by Star.Ryhwa",
    "image": "https://images.unsplash.com/photo-1572375992501-4b0892d50c69?q=80&w=600&auto=format&fit=crop",
    "tags": [
      "Photocard Holders"
    ]
  }
];

export default products;
